import { getAccountantData } from 'api/v3/access/accountantsAuth';
import i18n from 'i18n';
import { useQuery, type UseQueryOptions } from 'react-query';
import { AccountCacheKeys } from 'types/cacheKeys.types';
import { AvailableLanguages } from 'types/users.types';
import { isExpert } from 'utils/constants';
import { getStoredExpertAuthData } from 'utils/expertAuth';

/**
 * Simple expert-specific version of useGetLoggedInUserData
 */
const useGetExpertLoggedInUserData = (options?: UseQueryOptions) => {
  const authData = getStoredExpertAuthData();
  const enabled = isExpert && !!authData?.auth?.access_token;

  return useQuery([AccountCacheKeys.AccountantData], getAccountantData, {
    enabled,
    onSuccess: (accountant) => {
      const storedPreferred = localStorage.getItem(
        'preferredExpertLanguage',
      ) as AvailableLanguages | null;
      const userLanguage = accountant.language || AvailableLanguages.en;
      const effectiveLanguage = storedPreferred || userLanguage;

      if (i18n.language !== effectiveLanguage) {
        i18n.changeLanguage(effectiveLanguage);
      }

      if (storedPreferred) {
        localStorage.removeItem('preferredExpertLanguage');
      }
    },
    ...(options as any),
  });
};

export default useGetExpertLoggedInUserData;
